module.exports = __webpack_public_path__ + "img/thermocouple-end-J.f2a13035.png";